module.exports = __webpack_public_path__ + "static/media/Background.292c1606.png";